<template>
    <!-- Integração SED: aluno SEM matrícula ativa (ex.: a outra cidade deu baixa por transferência) que a SED recusou por falta
         de inscrição. A escola de destino faz a Inscrição de Alunos (Fora da Rede) e depois conclui a matrícula normal. -->
    <el-dialog title="Inscrição de aluno de fora da rede (SED)" :visible="visible" @update:visible="fechar" @open="carregar" width="60%" append-to-body :close-on-click-modal="false">

        <div v-loading="carregando" style="min-height: 60px;">

            <template v-if="opcoes">

                <p class="u-mb-15 u-mt-20" style="color: #606266;">
                    A SED recusou a matrícula porque o aluno não tem inscrição para <b>{{ opcoes.destino.escola }}</b>.
                    Faça a inscrição de aluno de fora da rede e, em seguida, a matrícula é concluída.
                </p>

                <el-alert v-if="!opcoes.elegivel" type="error" :closable="false" show-icon :title="opcoes.motivo_inelegivel"></el-alert>

                <!-- Já inscrito: só falta concluir a matrícula (ou cancelar a inscrição) -->
                <template v-else-if="opcoes.inscricao_aberta">
                    <el-alert type="success" :closable="false" show-icon
                        :title="'Inscrição em aberto desde ' + opcoes.inscricao_aberta.data + ' (' + opcoes.inscricao_aberta.descricao + ')'">
                        Feche esta janela e clique em <b>CONCLUIR MATRÍCULA</b>.
                    </el-alert>
                </template>

                <template v-else>
                    <dl>
                        <dt>TIPO DE INSCRIÇÃO</dt>
                        <dd>{{ opcoes.fase.nome }} (fase {{ opcoes.fase.codigo }})</dd>
                    </dl>
                    <el-checkbox v-model="form.interesse_integral">Interesse pelo turno integral</el-checkbox>
                </template>

            </template>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="fechar(false)">Voltar</el-button>
            <el-button v-if="opcoes && opcoes.inscricao_aberta" type="danger" plain :loading="enviando" @click="cancelar">Cancelar inscrição</el-button>
            <el-button v-if="opcoes && opcoes.elegivel && !opcoes.inscricao_aberta" type="primary" :loading="enviando" @click="inscrever">Inscrever e concluir matrícula</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { mostrarThrow as mostrarThrowSed } from '@/shared/sed'

export default {
    props: ['visible', 'pedido'],
    data: () => ({
        carregando: false,
        enviando: false,
        opcoes: null,
        form: { interesse_integral: false }
    }),
    computed: {
        url() {
            return `${this.$store.state.config.baseUrlApi}/api/sed/aluno`;
        },
        base() {
            return { aluno_id: this.pedido.aluno_id, turma_id: this.pedido.turma_id, referencia_nacional: this.pedido.referencia_nacional };
        }
    },
    methods: {
        fechar(inscrito) {
            this.$emit('update:visible', false);
            if (inscrito === true) this.$emit('inscrito');
        },
        carregar() {
            this.opcoes = null;
            this.form = { interesse_integral: false };

            if (!this.pedido) return;

            this.carregando = true;

            this.$axios.post(this.url + '/inscricao-fora-rede/opcoes', this.base, this.$store.getters.getHeaderAuth).then(response => {

                this.carregando = false;

                if (mostrarThrowSed(this, response.data)) { this.fechar(false); return; }

                this.opcoes = response.data;

            }).catch((error) => { this.carregando = false; this.$store.commit('throwException', error); });
        },
        inscrever() {
            this.enviando = true;

            this.$axios.post(this.url + '/inscricao-fora-rede', Object.assign({}, this.base, this.form), this.$store.getters.getHeaderAuth).then(response => {

                this.enviando = false;

                if (mostrarThrowSed(this, response.data)) return;

                window.eventBus.$emit('alert', { msg: response.data.success, type: 'success' });
                this.fechar(true);

            }).catch((error) => { this.enviando = false; this.$store.commit('throwException', error); });
        },
        cancelar() {
            this.$confirm('Cancelar a inscrição deste aluno na SED?', 'Atenção', { confirmButtonText: 'Sim, cancelar', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                this.enviando = true;

                this.$axios.post(this.url + '/inscricao-transferencia/cancelar', this.base, this.$store.getters.getHeaderAuth).then(response => {

                    this.enviando = false;

                    if (mostrarThrowSed(this, response.data)) return;

                    window.eventBus.$emit('alert', { msg: response.data.success, type: 'success' });
                    this.carregar();

                }).catch((error) => { this.enviando = false; this.$store.commit('throwException', error); });

            }).catch(() => {});
        }
    }
}
</script>
